export const LOADING_TECNICAL_KNOWLEDGE_ACQUIRED = "LOADING_TECNICAL_KNOWLEDGE_ACQUIRED";
export const SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED = "SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED";
export const GET_TECNICAL_KNOWLEDGE_ACQUIRED = "GET_TECNICAL_KNOWLEDGE_ACQUIRED";
export const FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED = "FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED";
export const TECNICAL_KNOWLEDGE_ACQUIRED_FAIL = "TECNICAL_KNOWLEDGE_ACQUIRED_FAIL";
export const LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID = "LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID";
export const GET_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID = "GET_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID";
export const SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID = "SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID";
